import { render, staticRenderFns } from "./OnlineOrderForm.vue?vue&type=template&id=1cb6ee0f&scoped=true&"
import script from "./OnlineOrderForm.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb6ee0f",
  null
  
)

export default component.exports